import { ACTIVE_USER_TAB, LIST_USER_FRIENDS, DETAIL_USER_FRIEND, LIST_USER_GALLERY, DETAIL_USER_PROFILE, DROPDOWN_USER_FRIEND, LIST_TIMELINE, DELETE_FEED, CHANGE_PROFILE_PIC, SET_CURRENT_USER } from './constants';
import { USER_FRIENDS } from './constants';
import { getPublicIP, getAuthHeader } from "../helpers/authHelper";
import { getReq , putReq, postReq} from './rest';
import { handleResponse, loader, pageloader} from './utils';
import { setJWTToken } from "../helpers/authHelper";

export const currentActiveTab = (tabindex) => {
    return {
      type: ACTIVE_USER_TAB,
      tabindex,
    }; 
};
export const userFriendList = (friendList,totalfriend,pagination) => {
    return {
      type: LIST_USER_FRIENDS,
      friendList,
      totalfriend,
      pagination
    }; 
};

export const userGalleryList = (albumList,totalAlbum,uploadList,totalUpload,dedicateList,totalDedicates,pagination) => {
  return {
    type: LIST_USER_GALLERY,
    albumList,
    totalAlbum,
    uploadList,
    totalUpload,
    dedicateList,
    totalDedicates,
    pagination
  }; 
};

export const userFriendDetail = (friendDetail) => {
  return {
    type: DETAIL_USER_FRIEND,
    friendDetail
  }; 
};

export const changeTab = (params) => {
    return (dispatch,getState) => {
        dispatch(currentActiveTab(params));
    }
};

export const userProfileDetails = (profile) => {
  return {
    type: DETAIL_USER_PROFILE,
    profile,
  }; 
};

export const userProfileUpdate = (profile) => {
  return {
   /*  type: DETAIL_USER_PROFILE,
    profile, */
  }; 
};

export const userFriendDropdown = (userFriendDropdown) => {
  return {
    type: DROPDOWN_USER_FRIEND,
    userFriendDropdown,
  }; 
};

export const listFeed = (listfeed,countertimeline,pagination) => {
  return {
    type: LIST_TIMELINE,
    listfeed,
    countertimeline,
    pagination
  }; 
};
export const deleteFeed = (deleteFeed) => {
  return {
    type: DELETE_FEED,
    deleteFeed
  }; 
};

/*
 Name         : fetchUserFriendList
 Description  : fetch all friendlist
*/
export const fetchUserFriendList = (params) => {
    return (dispatch, getState) => {
        const pagination = (params != null) ? params.pagination : 0;
        const bodyFormData = new FormData();
        const {login} = getState();
        if (pagination == 0) {
          loader(true);
        }else{
          pageloader(true);
        }
        bodyFormData.set('user_id', params.urlId);
        bodyFormData.set('pagination', pagination);
        bodyFormData.set('is_goldenspace', null);
        bodyFormData.set('search_text', '');
       
        const headers = getAuthHeader();
        postReq(`${apiURLPrefix}/userprofile/user_timelinefriend`, bodyFormData , headers)
        .then(handleResponse)
        .then((res) => {
          dispatch(userFriendList(res.friend_details,res.total_friend,pagination));
          dispatch(userFriendDetail(res.current_friend));
        }).catch((err)=>{
          console.log(err)
        }) 
    }  
};

/*
 Name         : fetchUserAlbumList
 Description  : fetch all media list
*/ 
export const fetchUserAlbumList = (params) => {
  
  return (dispatch, getState) => {
      const pagination = (params != null) ? params.pagination : 0;
      const bodyFormData = new FormData();
      const {login} = getState();
      if (pagination === 0) {
        loader(true);
      }else{
         pageloader(true);
      }
      bodyFormData.set('user_id', params.urlId);
      bodyFormData.set('pagination', pagination);
                
      const headers = getAuthHeader();
      postReq(`${apiURLPrefix}/userprofile/user_timelinegallery`, bodyFormData , headers)
      .then(handleResponse)
      .then((res) => {
        dispatch(userGalleryList(res.album_details,res.total_album,res.uploads_details,res.total_uploads,res.dedicates_details,res.total_dedicates,pagination));
        dispatch(userFriendDetail(res.current_friend));
      }).catch((err)=>{
        console.log(err)
      }) 
  }  
};

/*
 Name         : fetchUserProfile
 Description  : fetch profile details
*/ 
export const fetchUserProfile = (params) => {
  return (dispatch, getState) => {
      const bodyFormData = new FormData();
      loader(true);
      bodyFormData.set('user_id', params.urlId);
      bodyFormData.set('max_value', 0);
      
      const headers = getAuthHeader();
      postReq(`${apiURLPrefix}/user/user_profile`, bodyFormData , headers)
      .then(handleResponse)
      .then((res) => {
       let newObj ={
        career: "",
        city: "",
        country_name: res.country_name,
        email: "",
        fetch_profile_details: res.fetch_profile_details,
        full_name: `${res.first_name} ${res.last_name}`,
        has_golden_space: "",
        id: res.id,
        is_email_verified: "",
        is_following: res.is_following,
        is_friend: res.is_friend,
        is_phone_verified: "",
        is_user_active: "",
        membership: res.membership,
        membership_upgrade_status: "",
        phone: "",
        phone_country_code: "",
        state: "",
        users_profile_image: res.image,
        users_profile_image_id: ""
       }       

        dispatch(userProfileDetails(res.new_response));
        dispatch(userFriendDetail(newObj));
      }).catch((err)=>{
        console.log(err)
      }) 
  }  
};

export const updateUserProfile = (params) => {
  return (dispatch, getState) => {
      const bodyFormData = new FormData();
      const {login} = getState();
      loader(true);
      bodyFormData.set('user_id', login.user.id);
      bodyFormData.set('updated_field', params.updated_field);
      bodyFormData.set('field_type', params.field_type);
      
      const headers = getAuthHeader();
      postReq(`${apiURLPrefix}/user/update_user_profile`, bodyFormData , headers)
      .then(handleResponse)
      .then((res) => {
        dispatch(userProfileUpdate(res.new_response));
      }).catch((err)=>{
        console.log(err)
      }) 
  }  
};

export const fetchUserFriendDropdown = (params) => {
  return (dispatch, getState) => {
      const bodyFormData = new FormData();
      const {login} = getState();
      loader(true);
      bodyFormData.set('user_id', login.user.id);
      bodyFormData.set('search_text', '');
      bodyFormData.set('flag', params);
      
      const headers = getAuthHeader();
      postReq(`${apiURLPrefix}/userprofile/user_friendlist`, bodyFormData , headers)
      .then(handleResponse)
      .then((res) => {
        console.log('checktype',params);
        dispatch(userFriendDropdown((params == 'ALL') ? res.friend_details : res.page_details));
      }).catch((err)=>{
        console.log(err)
      }) 
  }  
};

export const deleteProfileDetail = (id,type) => {
  return (dispatch, getState) => {
      const bodyFormData = new FormData();
      const {login} = getState();
      loader(true);
      bodyFormData.set('id', id);
      bodyFormData.set('type', type);
            
      const headers = getAuthHeader();
      postReq(`${apiURLPrefix}/user/delete_profile_others_details`, bodyFormData , headers)
      .then(handleResponse)
      .then((res) => {
       
       // dispatch(userFriendDropdown((params == 'ALL') ? res.friend_details : res.page_details));
      }).catch((err)=>{
        console.log(err)
      }) 
  }  
};

export const fetchTimelineRequest = (params = null) => {
  return (dispatch, getState) => {
    const pagination = (params != null) ? params.pagination : 0;
    const bodyFormData = new FormData();
    const {login} = getState();
      
    bodyFormData.set('pagination', pagination);
    bodyFormData.set('user_id',params.urlId);
    bodyFormData.set('loggedin_user_id',login.user.id);
    if(pagination == 0){
      loader(true);
    }else{
      pageloader(true);
    }
    
    const headers = getAuthHeader();
    postReq(`${apiURLPrefix}/userprofile/user_timelinefeed`, bodyFormData , headers)
    .then(handleResponse)
    .then((res) => {
      pageloader(false);
      dispatch(listFeed(res.feed_details,res.total_counter,pagination));
      dispatch(userFriendDetail(res.current_friend));
    }).catch((err)=>{
      pageloader(false);
      console.log(err)
    }) 
  }  
};

export const deleteUserFeed = (params = null) => {
  return (dispatch, getState) => {
    const pagination = (params != null) ? params.pagination : 0;
    const bodyFormData = new FormData();
    bodyFormData.set('post_id', params.postid);
    bodyFormData.set('feed_id', params.feedid);
    bodyFormData.set('feed_type', params.feedtype);
    
    pageloader(true);
    const headers = getAuthHeader();
    postReq(`${apiURLPrefix}/userfeed/delete_userpost`, bodyFormData , headers)
    .then(handleResponse)
    .then((res) => {
      pageloader(false);
      dispatch(deleteFeed({post_id:params.postid,feed_id: params.feedid}));
    }).catch((err)=>{
      pageloader(false);
      console.log(err)
    }) 
  }  
};


export const updateProfilepic = (profilePic) => {
  return {
    type: CHANGE_PROFILE_PIC,
    profilePic
  }; 
};

export const loginUser = (user) => {
 
  return {
    type: SET_CURRENT_USER,
    user,
  };
};
export const profilePictureUpload = (params = null) => {

  return (dispatch, getState) => {
    const {login} = getState();
    const bodyFormData = new FormData();
    bodyFormData.set('updated_field', params.updated_field);
    bodyFormData.set('user_id', login.user.id);
    bodyFormData.set('field_type', "Others");
    const headers = getAuthHeader();
    postReq(`${apiURLPrefix}/user/update_user_profile`, bodyFormData , headers)
    .then(handleResponse)
    .then((res) => {
      dispatch(updateProfilepic(res));
      dispatch(loginUser(params.user));
    }).catch((err)=>{
      
      console.log(err)
    }) 
  }  
};




